module.exports = {
    EMOJI_PROPERTY_NAME: 'n',
    EMOJI_PROPERTY_UNIFIED: 'u',
    EMOJI_PROPERTY_SKIN_VARIATIONS: 'v',
    EMOJI_PROPERTY_GROUP: 'g',
    GROUP_NAME_PEOPLE: 'smileys & people',
    GROUP_NAME_NATURE: 'animals & nature',
    GROUP_NAME_FOOD: 'food & drink',
    GROUP_NAME_TRAVEL: 'travel & places',
    GROUP_NAME_ACTIVITIES: 'activities',
    GROUP_NAME_OBJECTS: 'objects',
    GROUP_NAME_SYMBOLS: 'symbols',
    GROUP_NAME_FLAGS: 'flags',
    GROUP_NAME_RECENTLY_USED: 'Recently Used',
};

